package com.jingfangpai.signSymptom.model

import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class SignSymptomIdAndName {
    var id:String?=null
    var name:SignSymptomName?=null
}